import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox/TextBox.styled'
import { RowContainerSC } from 'containers/RowContainer/NewRowContainer.styled'
import { SimpleCarouselScrollableComponentSC } from 'containers/RowContainer/RowSimpleContainer/SimpleCarouselScrollable.styled'
import { COLOR, FIXED_INDENTS, MEDIA } from 'vars/index'

export const PlayerRecommendationsLayoutSC = styled.div`
  width: 100dvw;
  height: 100dvh;
  z-index: 12;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: var(${COLOR.SURFACE_OPACITY_DARK_50});
  pointer-events: auto;
`

export const RecommendationsContentSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100dvw;
  box-sizing: border-box;

  ${RowContainerSC} {
    width: 100%;

    ${SimpleCarouselScrollableComponentSC} {
      --rowGap: var(${FIXED_INDENTS.INDENT_30});
      padding-top: var(${FIXED_INDENTS.INDENT_60});
      padding-bottom: var(${FIXED_INDENTS.INDENT_60});

      ${MEDIA.MIN_1240} {
        padding-top: var(${FIXED_INDENTS.INDENT_100});
        padding-bottom: var(${FIXED_INDENTS.INDENT_100});
      }
    }
  }
`

export const RecommendationsTitleSC = styled.div`
  width: 200px;
  max-width: 100%;
  padding: 0;
  box-sizing: border-box;

  ${MEDIA.MIN_600} {
    width: 100%;
    padding: 0 var(${FIXED_INDENTS.INDENT_40});
  }

  ${TextBoxSC} {
    white-space: pre-wrap;
  }

  ${MEDIA.MIN_1240} {
    ${TextBoxSC} {
      white-space: normal;
    }
  }
`

export const CloseHeaderSC = styled.div`
  position: absolute;
  z-index: 1;
  top: 24px;
  right: 24px;

  ${MEDIA.MIN_1240} {
    top: 40px;
    right: 48px;
  }

  ${MEDIA.MIN_1640} {
    top: 48px;
    right: 64px;
  }
`
